// LOGIC BASED ON THIS -> https://docs.google.com/spreadsheets/d/149sw6F-t74ulkFCJKqyCGJrhiHUv-73SeVsqPGuiCTE/edit?gid=913777753#gid=913777753

// LOGIC SECOND ITERATION -> https://docs.google.com/spreadsheets/d/1puXE3rnJ1opjcvN7z_8fl45GT4LRnz9mKS0g4YpTnbY/edit?gid=1226897091#gid=1226897091

import { seFbclid } from "./services.js";
import { nanoid } from 'nanoid'

const determineBrandMatch = async (answers) => {

  try {
    const fbclid = seFbclid();
    const payLoad = { ...answers, uuid: nanoid(6), fbclid: fbclid, form_id: 'medical-guardian-com' };
    const result = await fetch('/form_submission/submit_form', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payLoad)
      });
  
      const response = await result.json();
      console.log(response);

      if (response && response.brandMatch) {
        return response.brandMatch
      }

      return "No match found"
  } catch (ex) {
    console.log(ex);
  }

  };
  export default determineBrandMatch;